import { ssoRequest, customerRequest } from '@/services'
import { Notify } from 'vant'
import { arrFlattening } from '@/utils/basicUtil'
export default {
  namespace: 'user',
  state: {
    menuList: [],
    extendField: [],
    changeCompanyFlag: false,
    company: {
      companyInfoResponse: {
      }
    },
    userInfo: {

    },
    dataSource: {
      totalAmount: 0,
      totalNum: 0,
      unCreateInvoiceQuantity: 0,
      unSendQuantity: 0,
      unSignedQuantity: 0,
      specialInvQuantity: 0,
      generalInvQuantity: 0,
      electronicInvQuantity: 0
    },
    message: {
      title: ''
    },
    showMessage: true,
    refreshStatistics: false,
    ukeyBox: {
      phone: '',
      snCode: ''
    },
    dingConfig: {
      appId: '', // appId
      mainCropId: '', // 主企业的CropId
      cropId: '', // 当前企业的CropId
      status: 2 // 0主企业未开通，1主企业已开通，2当前组织不是个人组织
    }
  },
  mutations: {
    changeCompany (state, company) {
      state.company = company
    },
    changeExtendField (state, extendField) {
      state.extendField = extendField
    },
    changeMenuList (state, menuList) {
      console.log(menuList)
      state.menuList = menuList
    },
    changeUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    changeDataSource (state, dataSource) {
      state.dataSource = dataSource
    },
    changeMessage (state, message) {
      state.message = message
    },
    changeChangeCompanyFlag (state, changeCompanyFlag) {
      state.changeCompanyFlag = changeCompanyFlag
    },
    changeShowMessage (state, showMessage) {
      state.showMessage = showMessage
    },
    changeRefreshStatistics (state, refreshStatistics) {
      state.refreshStatistics = refreshStatistics
    },
    changeUkeyBox (state, ukeyBox) {
      state.ukeyBox = ukeyBox
    },
    changeDingConfig (state, dingConfig) {
      state.dingConfig = dingConfig
    }
  },
  actions: {
    async getExtendField ({ commit }, { applyModule }) {
      const res = await customerRequest.extendField.getExtendField({ extSource: 0, applyModule })
      if (res.success) {
        await commit('changeExtendField', res.result)
      }
    },
    async getNotAuthExtendField ({ commit }, { applyModule, secretKey }) {
      const res = await customerRequest.extendField.getNotAuthExtendField({ extSource: 0, applyModule, secretKey })
      if (res.success) {
        await commit('changeExtendField', res.result)
      }
    },
    async getInviteParam ({ commit, state }) {
      const result = await ssoRequest.ding.getInviteParam({})
      if (result.success) {
        const dingConfig = {
          appId: result.result.appId,
          mainCropId: result.result.mainCropId,
          cropId: result.result.cropId,
          status: result.result.status
        }
        await commit('changeDingConfig', dingConfig)
      } else {
        Notify({ type: 'danger', message: result.message })
      }
    },
    async getJurisdiction ({ commit }) {
      const result = await ssoRequest.ding.getJurisdiction({ requestSource: '3' })
      if (result.success && result.result && Array.isArray(result.result)) {
        await commit('changeMenuList', arrFlattening(result.result, 'nodes') || result.result || [])
        return arrFlattening(result.result, 'nodes') || result.result || []
      }
    }
  }
}
